"use client"

import React from "react"
import styled from "styled-components"
import Icon from "@motorata/base-ui.components.atoms.icon";
import { LabelH2, P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockStyles, Box } from "@motorata/base-ui.components.atoms._atoms";

const Block = ({ icon, title, text }: { icon: string; title: string; text: string }) => {
  return (
    <BlockWrapper>
      <IconWrapper>
        <Box>
          <Icon width="25px" icon={icon} color="primary" />
        </Box>
      </IconWrapper>
      <LabelH2 textAlign="center">{title}</LabelH2>
      <P small textAlign="center">
        {text}
      </P>
    </BlockWrapper>
  )
}

const FinanceAdvantagesSection = () => {
  return (
    <Wrapper id="advantages">
      <Title label="Dlaczego my" elementType="label" center>
        Korzyści dla Ciebie
      </Title>
      <Content>
        <Block
          icon="clock-check"
          title="Szybka procedura"
          text="Otrzymasz zgodę na finansowanie nawet tego samego dnia! Uproszczone procedury to minimum formalności i informacje, które zawrzesz w jednej wiadomości."
        />
        <Block
          icon="gear"
          title="Zautomatyzowany proces"
          text="W jednym miejscu podasz potrzebne informacje, aby uzyskać finansowanie oraz dodatkowe usługi."
        />
        <Block
          icon="calendar-heart"
          title="Podgląd harmonogramu"
          text="Tylko na naszej platformie możesz przejrzeć harmonogram umowy jeszcze przed jej zawarciem."
        />
        <Block
          icon="user-circle"
          title="Indywidualny doradca"
          text="Otrzymasz opiekę osobistego konsultanta, który pomoże wyszukać pojazd i przygotować umowę oraz zorganizuje potrzebne dodatkowe usługi. Nie musisz się już martwić o ubezpieczenie lub opony!"
        />
        <Block
          icon="lock"
          title="Gwarancja bezpieczeństwa"
          text="Korzystamy wyłącznie z autoryzowanych dostawców pojazdów oraz usług dodatkowych. Dokonamy również wstępnej weryfikacji dostawcy wybranego przez Ciebie pojazdu!"
        />
        <Block
          icon="shield"
          title="Wszechstronna opieka"
          text="Dla Twojego osobistego konsultanta nie ma pytania bez odpowiedzi. Przez cały czas użytkowania Twojego nowego samochodu możesz zwrócić się o pomoc i poradę."
        />
      </Content>
    </Wrapper>
  )
}

export default FinanceAdvantagesSection

const IconWrapper = styled.div`
  margin-bottom: 1.5rem;
  background: ${({ theme }) => theme.color.primaryBackgroundDarker};
  border-radius: 50px;
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    width: 45px;
    border-radius: 50px;
    height: 45px;
    background: ${({ theme }) => theme.color.primaryBackgroundDarker};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // border-radius: 5px;
`

const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  margin: 2rem;
  
  @media (max-width: 600px){
    margin: 2rem 0;
    max-width: none;
  }
`

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 auto;
  
  @media (max-width: 900px){
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px){
    grid-template-columns: 1fr;
  }
`

const Wrapper = styled.div`
  ${blockStyles};
`
